import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

export const Clock: React.FC = () => {
  const [time, setTime] = useState<string>(new Date().toLocaleTimeString());
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);
    
    return () => {
      clearInterval(timer);
    };
  }, []);
  
  return (
    <Typography 
      variant="body2" 
      sx={{ 
        textAlign: 'left',
        color: 'text.primary',
        fontSize: '1rem',
        fontWeight: 'bold'
      }}
    >
      {time}
    </Typography>
  );
};